module.exports = __webpack_public_path__ + "img/call_response_logo.c9b8e1f9.svg";